"use strict";
/**
 * URL paths for in-app pages.
 *
 * The app is one bundle with `.page` containers, so a page is normally only
 * reachable by tapping through the app: it has no URL, cannot be bookmarked,
 * and a reload loses it. A route here gives a page a real path — the server
 * serves the shell for it, and the client restores the page from
 * `location.pathname`.
 *
 * Everything lives under `/app/` because the API routers own the bare
 * top-level paths (`/win-prob`, `/pnl`, …). Without the prefix a UI path and
 * an API namespace would be the same string.
 *
 * `segments` are the path parts after `path`, e.g. `/app/win-prob/nfl/12345`
 * yields `["nfl", "12345"]`, so a page can deep-link to one item.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_ROUTES = exports.APP_ROUTE_PREFIX = void 0;
exports.matchAppRoute = matchAppRoute;
exports.appRoutePath = appRoutePath;
exports.APP_ROUTE_PREFIX = "/app";
exports.APP_ROUTES = [
    { path: "/app/win-prob", page: "win-prob", deep: true },
];
/** The route owning this pathname, with any trailing segments. */
function matchAppRoute(pathname) {
    const clean = pathname.replace(/\/+$/, "") || "/";
    for (const route of exports.APP_ROUTES) {
        if (clean === route.path)
            return { route, segments: [] };
        if (route.deep && clean.startsWith(`${route.path}/`)) {
            return { route, segments: clean.slice(route.path.length + 1).split("/").filter(Boolean) };
        }
    }
    return null;
}
/** Path for a page, optionally deep-linked. Inverse of matchAppRoute. */
function appRoutePath(page, segments = []) {
    const route = exports.APP_ROUTES.find((r) => r.page === page);
    if (!route)
        return null;
    if (segments.length === 0)
        return route.path;
    if (!route.deep)
        return route.path;
    return `${route.path}/${segments.map(encodeURIComponent).join("/")}`;
}
